import * as React from 'react';
import { typeOfComponent } from '../typeOfComponent';
export var processTypes = function (types) { return types.map(function (x) {
    switch (typeof x) {
        case 'string':
            return x;
        case 'function':
            return typeOfComponent(React.createElement(x));
        default:
            return typeOfComponent(x);
    }
}); };
